import { DataType } from "./types";

export const dataSource: DataType[] = [
  {
    key: "1",
    fullName: {
      name: "Арбуз",
      description: "Описание11",
    },
    docNumber: "200/1, 306-1/1",
    date: "27.12.2025",
    issuer: 'ООО "Стиль Комплект"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
    ],
    page: "1",
    author: {
      name: "Загружаев А. В.",
      org: 'ООО "Загружайка"',
    },
    workDraw: "1",
    docName: {
      name: "Арбуз",
      description: "Описание11",
    },
    code: "1234567890",
    expiryDate: "28.12.2025",
    producer: "ООО 'Производитель'",
  },
  {
    key: "2",
    fullName: {
      name: "Букварь",
      description: "Описание22",
    },
    docNumber: "1234567890",
    date: "15.08.2025",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
      {
        id: "2",
        name: "Штамп 2",
        status: "declined",
      },
      {
        id: "3",
        name: "Штамп 1",
        status: "pending",
      },
      {
        id: "4",
        name: "Штамп 1",
        status: "pending",
      },
      {
        id: "5",
        name: "Штамп 1",
        status: "pending",
      },
      {
        id: "6",
        name: "Штамп 1",
        status: "declined",
      },

      {
        id: "7",
        name: "Штамп 1",
        status: "signed",
      },

      {
        id: "8",
        name: "Штамп 1",
        status: "pending",
      },

      {
        id: "9",
        name: "Штамп 1",
        status: "signed",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Букварь",
      description: "Описание22",
    },
    code: "1234567890",
    expiryDate: "16.08.2025",
    producer: "ООО 'Производитель'",
  },
  {
    key: "3",
    fullName: {
      name: "Виноград",
      description: "Описание33",
    },
    docNumber: "1234567890",
    date: "25.10.2021",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Виноград",
      description: "Описание33",
    },
    code: "1234567890",
    expiryDate: "26.10.2021",
    producer: "ООО 'Производитель'",
  },
  {
    key: "4",
    fullName: {
      name: "Грибы",
      description: "Описание44",
    },
    docNumber: "1234567890",
    date: "01.02.2024",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
      {
        id: "2",
        name: "Штамп 2",
        status: "declined",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Грибы",
      description: "Описание44",
    },
    code: "1234567890",
    expiryDate: "02.02.2024",
    producer: "ООО 'Производитель'",
  },
  {
    key: "5",
    fullName: {
      name: "Дыня",
      description: "Описание55",
    },
    docNumber: "1234567890",
    date: "22.11.2027",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Дыня",
      description: "Описание55",
    },
    code: "1234567890",
    expiryDate: "23.11.2027",
    producer: "ООО 'Производитель'",
  },
  {
    key: "6",
    fullName: {
      name: "Икра",
      description: "Описание66",
    },
    docNumber: "1234567890",
    date: "22.11.2027",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "declined",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Икра",
      description: "Описание66",
    },
    code: "1234567890",
    expiryDate: "23.11.2027",
    producer: "ООО 'Производитель'",
  },
  {
    key: "7",
    fullName: {
      name: "Клубника",
      description: "Описание77",
    },
    docNumber: "1234567890",
    date: "22.11.2027",
    issuer: 'ГУП "МосОблЭнерго"',
    stamps: [
      {
        id: "1",
        name: "Штамп 1",
        status: "signed",
      },
    ],
    page: "1",
    author: {
      name: "Иванов И.И.",
      org: 'ООО "Иванов и Ко"',
    },
    workDraw: "1",
    docName: {
      name: "Клубника",
      description: "Описание77",
    },
    code: "1234567890",
    expiryDate: "23.11.2027",
    producer: "ООО 'Производитель'",
  },
];
